module.exports = __webpack_public_path__ + "media/images/pages/home_featured/homepage-contest-banner-ced50306943c247a70086785e71b46e2.png";